export const GET_DIT_USER_DETAILS = 'GET_DIT_USER_DETAILS';
export const GET_DIT_USER_DETAILS_SUCCESS = 'GET_DIT_USER_DETAILS_SUCCESS';
export const GET_DIT_USER_DETAILS_FAILURE = 'GetDITUser_DETAILS_FAILURE';

